import { StatusSpinner as SpinnerBase } from '@repay/cactus-icons';
import styled, { keyframes } from 'styled-components';
var rotate = /*#__PURE__*/keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
export var Spinner = /*#__PURE__*/styled(SpinnerBase).withConfig({
  displayName: "Spinner"
})(["animation:", " 0.75s linear infinite;"], rotate);
Spinner.defaultProps = {
  iconSize: 'large'
};
export default Spinner;